/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="results && results.scores"
    class="score-container svg-container"
    tabindex="-1"
    v-html="varietyChart"
  />
</template>

<script>
import ChartHelper from '../utils/ChartHelper';

export default {
  mixins: [ChartHelper],
  props: ['recording', 'wavesurfer', 'speakerNum', 'metric', 'tooltipId'],
  data() {
    return {
    };
  },
  computed: {
    varietyChart() {
      const segments = this.results.timestamped[this.metric].segments,
        bars = _.map(segments, seg => {
          const barSize = Math.min(Math.max(4 + seg.spread,0),8);
          return Math.round(barSize * 10)/10;
        }),
        pad = v => {
          return _.padStart(Math.floor(v).toFixed(0),2,'0');
        },
        time = t => {
          if (t < 3600) {
            return `${pad(t/60)}:${pad(t%60)}`;
          }
          return `${pad(t/3600)}:${pad((t/60)%60)}:${pad(t%60)}`;
        },
        duration = time(this.recording.duration);

      let svg = `<svg viewBox="0 0 230 110" class="variety-chart">
        <g>
          <polyline fill="none" stroke="#999" stroke-width="1" points="9,9 9,91 211,91" />
          <text fill="#999" x="9" y="102" text-anchor="start" font-size="10">00:00</text>
          <text fill="#999" x="211" y="102" text-anchor="end" font-size="10">${duration}</text>
        </g>
        <g>
          <rect x="10" y="10" width="200" height="80" class="variety-bg" />`;

      for (let s=0; s<20; s++) {
        let rectX = 10 + s * 10,
          rectY = 90 - bars[s] * 10,
          rectHeight = bars[s] * 10;

        if (bars[s]) {
          svg += `<g>
            <rect class="variety-bar" x="${rectX}" y="${rectY}" width="10" height="${rectHeight}" />
          </g>`;
        }
      }

      svg += '<g>';
      for (let v=0; v<9; v++) {
        let lineY1 = 90 - v * 10,
          lineY2 = 90 - v * 10;

        svg += `<line x1="10" y1="${lineY1}" x2="210" y2="${lineY2}" class="variety-line" />`;
      }

      for (let s=0; s<20; s++) {
        let lineX1 = 10 + s * 10,
          lineX2 = 10 + s * 10;

        svg += `<line x1="${lineX1}" y1="10" x2="${lineX2}" y2="90" class="variety-line" />`;
      }

      svg += '</g></g>';

      if (bars.length == 0) {
        svg += `<g class="variety-band">
          <text text-anchor="middle" font-size="10">
            <tspan x="111" y="53">Recording is too short to analyze.</tspan>
          </text>
        </g >`;
      }

      svg += `<g class="variety-band">
          <rect x="10" y="40" width="200" height="20" />
          <text text-anchor="start" font-size="8" transform="translate(215,53)">
            <tspan x="0" y="-4">IDEAL</tspan>
            <tspan x="0" y="6">RANGE</tspan>
          </text>
        </g>
      </svg>`;

      return svg;
    }
  },
  mounted() {
    this._addTooltip(this.tooltipId, this.recording, this.metric);
  },
};
</script>
